// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ----------------------------------------------------------------------------------------------- */
/* -------------------------  styles for connector paths when editing ---------------------------- */
/* ----------------------------------------------------------------------------------------------- */

/* jtk-connection-edit is set on an edge that is being edited. */
.jtk-connection-edit path {
    stroke:gold;
}

/* ----------------------------------------------------------------------------------------------- */
/* --------------------    Styles for Flowchart editor ------------------------------------------- */
/* ----------------------------------------------------------------------------------------------- */

.jtk-flowchart-handle {
    width:20px;
    height:20px;
    line-height: 20px;
    text-align: center;
    font-size:13px;
    border-radius:50%;
    background-color:#f7f6f6;
    cursor:move;
    z-index:10;
    color:black;
    box-shadow: 0 0 10px;
}

.jtk-flowchart-segment-drag {
    cursor:move;
    cursor:grab;
}

.jtk-flowchart-segment-drag-ns:before {
    content:"\\2195";
}

.jtk-flowchart-segment-drag-ew:before {
    content:"\\2194";
}

.jtk-flowchart-segment-drag:hover {
    background-color: white;
}

/* ----------------------------------------------------------------------------------------------- */
/* --------------------    Styles for Bezier/StateMachine editor --------------------------------- */
/* ----------------------------------------------------------------------------------------------- */

/*
    Identifies a handle used to drag a control point.
*/
.jtk-bezier-handle {
    width:15px;
    height:15px;
    line-height:15px;
    border-radius:50%;
    background-color:darkcyan;
    cursor:move;
    z-index:10;
    font-size:8px;
    font-family: sans-serif;
    color: white;
    text-align: center;
}

.jtk-bezier-handle-control-point { }

/*
    The drag handle corresponding to the first control point. For StateMachine connectors only this handle is shown.
 */
.jtk-bezier-handle-control-point-1:before {
    content:"1";
}

/*
    The drag handle corresponding to the second control point. For StateMachine connectors only this handle is shown.
 */
.jtk-bezier-handle-control-point-2:before {
    content:"2";
}

.jtk-bezier-handle-control-point-3:before {
    content:"3";
}

.jtk-bezier-handle-control-point-4:before {
    content:"4";
}

.jtk-bezier-handle-secondary {
    cursor:default;
    background-color:lightgreen;
}

.jtk-bezier-handle-secondary-source {
    background-color: lavenderblush;
}

.jtk-bezier-guideline {
    position:absolute;
    stroke-dasharray: 2;
}

.jtk-bezier-guideline path {
    stroke:darkcyan;
    stroke-linewidth:3;
}

/* ----------------------------------------------------------------------------------------------- */
/* -----------------------------   Styles for anchor placeholders -------------------------------- */
/* ----------------------------------------------------------------------------------------------- */

/*
    Added to the element placed at the location of an anchor for a connection that is being edited. This applies
    to both dynamic and continuous anchors. Fixed anchors cannot be relocated.
*/
.jtk-anchor-placeholder {
    width: 20px;
    height: 20px;
    cursor: move;
    cursor:grab;
    border-radius: 50%;
    background-color:#f7f6f6;
    box-shadow: 0 0 4px;
}

/*
    Added to the elements drawn to show where a certain anchor may be relocated to (for dynamic anchors)
*/
.jtk-anchor-candidate {
    background-color:mediumseagreen;
    width: 20px;
    height: 20px;
}

/*
    \`jtk-anchor-face\` is an attribute written onto an element (source or target) when the connection that is being edited
    has \`Continuous\` anchors, and the user is dragging an anchor point to relocate it. The value of the attribute is the
    candidate face on the element.
 */
[jtk-anchor-face='left'] {
    border-left:4px solid gold !important;
}

[jtk-anchor-face='top'] {
    border-top:4px solid gold !important;
}

[jtk-anchor-face='right'] {
    border-right:4px solid gold !important;
}

[jtk-anchor-face='bottom'] {
    border-bottom:4px solid gold !important;
}


/* --------------------------------------------------------------------------------------------------------------------- */
/* --------------------------- edge delete button ---------------------------------------------------------------------- */
/* --------------------------------------------------------------------------------------------------------------------- */

.jtk-edge-delete {
    width:15px;
    height:15px;
    line-height: 15px;
    text-align: center;
    background-color:orangered;
    color:white;
    border-radius:50%;
    font-size:8px;
    cursor:pointer;
    font-family:sans-serif;
}

.jtk-edge-delete:before {
    content:"X";
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/jsplumbtoolkit-editable-connectors.css"],"names":[],"mappings":"AAAA,oGAAoG;AACpG,oGAAoG;AACpG,oGAAoG;;AAEpG,gEAAgE;AAChE;IACI,WAAW;AACf;;AAEA,oGAAoG;AACpG,oGAAoG;AACpG,oGAAoG;;AAEpG;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,WAAW;IACX,UAAU;IACV,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,oGAAoG;AACpG,oGAAoG;AACpG,oGAAoG;;AAEpG;;CAEC;AACD;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,mCAAmC;;AAEnC;;EAEE;AACF;IACI,WAAW;AACf;;AAEA;;EAEE;AACF;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,oGAAoG;AACpG,oGAAoG;AACpG,oGAAoG;;AAEpG;;;CAGC;AACD;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;;CAEC;AACD;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;AAChB;;AAEA;;;;EAIE;AACF;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;;AAGA,0HAA0H;AAC1H,0HAA0H;AAC1H,0HAA0H;;AAE1H;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* ----------------------------------------------------------------------------------------------- */\r\n/* -------------------------  styles for connector paths when editing ---------------------------- */\r\n/* ----------------------------------------------------------------------------------------------- */\r\n\r\n/* jtk-connection-edit is set on an edge that is being edited. */\r\n.jtk-connection-edit path {\r\n    stroke:gold;\r\n}\r\n\r\n/* ----------------------------------------------------------------------------------------------- */\r\n/* --------------------    Styles for Flowchart editor ------------------------------------------- */\r\n/* ----------------------------------------------------------------------------------------------- */\r\n\r\n.jtk-flowchart-handle {\r\n    width:20px;\r\n    height:20px;\r\n    line-height: 20px;\r\n    text-align: center;\r\n    font-size:13px;\r\n    border-radius:50%;\r\n    background-color:#f7f6f6;\r\n    cursor:move;\r\n    z-index:10;\r\n    color:black;\r\n    box-shadow: 0 0 10px;\r\n}\r\n\r\n.jtk-flowchart-segment-drag {\r\n    cursor:move;\r\n    cursor:grab;\r\n}\r\n\r\n.jtk-flowchart-segment-drag-ns:before {\r\n    content:\"\\2195\";\r\n}\r\n\r\n.jtk-flowchart-segment-drag-ew:before {\r\n    content:\"\\2194\";\r\n}\r\n\r\n.jtk-flowchart-segment-drag:hover {\r\n    background-color: white;\r\n}\r\n\r\n/* ----------------------------------------------------------------------------------------------- */\r\n/* --------------------    Styles for Bezier/StateMachine editor --------------------------------- */\r\n/* ----------------------------------------------------------------------------------------------- */\r\n\r\n/*\r\n    Identifies a handle used to drag a control point.\r\n*/\r\n.jtk-bezier-handle {\r\n    width:15px;\r\n    height:15px;\r\n    line-height:15px;\r\n    border-radius:50%;\r\n    background-color:darkcyan;\r\n    cursor:move;\r\n    z-index:10;\r\n    font-size:8px;\r\n    font-family: sans-serif;\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.jtk-bezier-handle-control-point { }\r\n\r\n/*\r\n    The drag handle corresponding to the first control point. For StateMachine connectors only this handle is shown.\r\n */\r\n.jtk-bezier-handle-control-point-1:before {\r\n    content:\"1\";\r\n}\r\n\r\n/*\r\n    The drag handle corresponding to the second control point. For StateMachine connectors only this handle is shown.\r\n */\r\n.jtk-bezier-handle-control-point-2:before {\r\n    content:\"2\";\r\n}\r\n\r\n.jtk-bezier-handle-control-point-3:before {\r\n    content:\"3\";\r\n}\r\n\r\n.jtk-bezier-handle-control-point-4:before {\r\n    content:\"4\";\r\n}\r\n\r\n.jtk-bezier-handle-secondary {\r\n    cursor:default;\r\n    background-color:lightgreen;\r\n}\r\n\r\n.jtk-bezier-handle-secondary-source {\r\n    background-color: lavenderblush;\r\n}\r\n\r\n.jtk-bezier-guideline {\r\n    position:absolute;\r\n    stroke-dasharray: 2;\r\n}\r\n\r\n.jtk-bezier-guideline path {\r\n    stroke:darkcyan;\r\n    stroke-linewidth:3;\r\n}\r\n\r\n/* ----------------------------------------------------------------------------------------------- */\r\n/* -----------------------------   Styles for anchor placeholders -------------------------------- */\r\n/* ----------------------------------------------------------------------------------------------- */\r\n\r\n/*\r\n    Added to the element placed at the location of an anchor for a connection that is being edited. This applies\r\n    to both dynamic and continuous anchors. Fixed anchors cannot be relocated.\r\n*/\r\n.jtk-anchor-placeholder {\r\n    width: 20px;\r\n    height: 20px;\r\n    cursor: move;\r\n    cursor:grab;\r\n    border-radius: 50%;\r\n    background-color:#f7f6f6;\r\n    box-shadow: 0 0 4px;\r\n}\r\n\r\n/*\r\n    Added to the elements drawn to show where a certain anchor may be relocated to (for dynamic anchors)\r\n*/\r\n.jtk-anchor-candidate {\r\n    background-color:mediumseagreen;\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n/*\r\n    `jtk-anchor-face` is an attribute written onto an element (source or target) when the connection that is being edited\r\n    has `Continuous` anchors, and the user is dragging an anchor point to relocate it. The value of the attribute is the\r\n    candidate face on the element.\r\n */\r\n[jtk-anchor-face='left'] {\r\n    border-left:4px solid gold !important;\r\n}\r\n\r\n[jtk-anchor-face='top'] {\r\n    border-top:4px solid gold !important;\r\n}\r\n\r\n[jtk-anchor-face='right'] {\r\n    border-right:4px solid gold !important;\r\n}\r\n\r\n[jtk-anchor-face='bottom'] {\r\n    border-bottom:4px solid gold !important;\r\n}\r\n\r\n\r\n/* --------------------------------------------------------------------------------------------------------------------- */\r\n/* --------------------------- edge delete button ---------------------------------------------------------------------- */\r\n/* --------------------------------------------------------------------------------------------------------------------- */\r\n\r\n.jtk-edge-delete {\r\n    width:15px;\r\n    height:15px;\r\n    line-height: 15px;\r\n    text-align: center;\r\n    background-color:orangered;\r\n    color:white;\r\n    border-radius:50%;\r\n    font-size:8px;\r\n    cursor:pointer;\r\n    font-family:sans-serif;\r\n}\r\n\r\n.jtk-edge-delete:before {\r\n    content:\"X\";\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
